import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {TableColumn} from "../../../classes/primeng/TableColumn";
import {Table} from "primeng/table";
import {Project} from "../../../types/sherpa";
import {ActivatedRoute, Router} from "@angular/router";
import _ from "lodash";
import {global} from 'src/globals';
import {UtilService} from "../../../services/util.service";
import {AdminService} from "../../../services/data/admin.service";
import {DialogService} from "primeng/dynamicdialog";
import {NewProjectComponent} from "../../modals/new-project/new-project.component";
import {ConfirmationService, MenuItem} from "primeng/api";
import {Globals} from "../../../classes/Globals";

@Component({
	selector: 'base-projects',
	templateUrl: './projects.component.html',
	styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit {

	@ViewChild('dt') table: Table;
	columns: TableColumn[] = [];
	fields: string[] = [];

	showProjectSidebar: boolean = false;
	selectedProject: Project;
	projects: Project[];

	global: Globals = global;
	private project_id: number = -1;
	private activatedProject: Project = null;
	loadingQuaysInProgress: Boolean = false;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private cd: ChangeDetectorRef,
		private projectsService: AdminService,
		private utilService: UtilService,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService) {

		this.projects = this.route.snapshot.data['projects'] as Project[];
		this.columns = [
			{field: 'id', header: 'ProjectID'},
			{field: 'division_code', header: 'Divisiecode'},
			{field: 'name', header: 'Naam'}
		];
	}

	ngOnInit(): void {
		this.route.queryParamMap.subscribe(params => {
			this.project_id = _.toInteger(params.get("project_id"));
			if (this.project_id == 0) {
				this.project_id = -1;
			}

			this.activatedProject = _.find(this.projects, (p: Project) => {
				return p.id === this.project_id;
			});

			if (this.activatedProject !== null && this.activatedProject !== undefined) {
				global.projectSubject.next(this.activatedProject);
			}

			this.refreshLoadingStatus();
		});
	}

	/* TABLE */
	loading: boolean;

	search(target: any) {
		this.table.filterGlobal(target.value, 'contains');
	}

	searchColumn(target: any, field: string, mode: 'startsWith' | 'contains' | 'endsWith' | 'equals' | 'notEquals' | 'in' | 'lt' | 'lte' | 'gt' | 'gte') {
		this.table.filter(target.value, field, mode);
	}

	onRowSelect(event: any) {
		this.showProjectSidebar = !this.showProjectSidebar;
	}

	onRowUnselect(event: any) {
		this.showProjectSidebar = !this.showProjectSidebar;
	}

	onRowClick(item: any) {
		this.selectedProject = null;
		this.cd.detectChanges();
		this.selectedProject = item;
		this.showProjectSidebar = !this.showProjectSidebar;
	}


	public close() {
		this.showProjectSidebar = false;
		this.selectedProject = null;
	}

	discardProject($event: Project) {
		this.confirmationService.confirm({
			message: `Weet u zeker dat u dit flexgebied wilt verwijderen? De database blijft wel bestaan.`,
			header: 'Verwijderen bevestigen',
			icon: 'pi pi-info-circle',
			accept: () => {
				this.projectsService.deleteProject($event).then(() => {
					this.projectsService.getProjects().then((result: Project[]) => {
						this.projects = result;
					});
				});
			},
			reject: () => {
			}
		});
	}

	updateProject($event: Project) {
		return this.projectsService.updateProject($event).then((result: Project) => {
			this.utilService.toast("Wijzigingen aan dit project zijn opgeslagen.", "", 'success', false);

			_.forEach(this.projects, (p: Project) => {
				if (p.id === result.id) {
					p.name = result.name;
					p.division_code = result.division_code;
				}
			});

			this.selectedProject = null;
			this.showProjectSidebar = false;

		});
	}

	newProject() {
		const ref = this.dialogService.open(NewProjectComponent, {
			width: '50%',
			showHeader: true,
			header: 'Nieuw flexgebied',
			data: {},
			baseZIndex: 1500
		});

		ref.onClose.subscribe((newProject: Project) => {
			if (newProject) {
				this.utilService.toast("Nieuw project '" + newProject.name + "' aangemaakt", "", "success", false);

				this.projectsService.getProjects().then((result: Project[]) => {
					this.projects = result;
				});
			}
		});
	}

	reload() {
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate(['./'], {relativeTo: this.route});
	}

	activateProject(item: Project) {

		this.activatedProject = item;
		global.projectSubject.next(item);
		global.activeProject = item;

		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		if (item != null) {
			this.router.navigate(['./'], {
				relativeTo: this.route,
				queryParams: {
					project_id: item.id
				},
				queryParamsHandling: 'merge'
			});
		} else {
			this.router.navigate([], {
				relativeTo: this.route,
				queryParams: {},
				queryParamsHandling: ''
			});
		}

		this.cd.markForCheck();
		this.cd.detectChanges();
	}

	isActive(item: Project) {
		return this.activatedProject?.id === item.id;
	}

	loadQuays(item: Project) {
		this.projectsService.loadAndRefeshQuaysInBackground(item.id).then((r) => {
				this.refreshLoadingStatus()
			}
		);
	}

	refreshLoadingStatus() {
		this.projectsService.getQuayLoadingStatus().then((loading: Boolean) => {
			this.loadingQuaysInProgress = loading;
		});
	}
}


